import * as React from "react";
import { useHistory } from "react-router-dom";
import { IUserList } from "../../resources/user/types";
import BackButton from "../../components/back-button";

import styles from "./user.module.css";

interface IProps {
  user: IUserList;
}

export default function User({ user }: IProps) {
  const history = useHistory();
  const onUserClick = (id: string) => () => history.push(`/users/${id}`);

  return (
    <div className={styles.user} onClick={onUserClick(user._id)}>
      <div className={styles.nameContainer}>
        <span className={styles.name}>
          {`${user.firstName} ${user.lastName}`}
        </span>
      </div>
      <div className={styles.gymName}>{user.gymName}</div>
      <BackButton className={styles.goButton} onClick={onUserClick(user._id)} />
    </div>
  );
}
